<div class="picker-min-premium">
  <div class="row">
    <label>
      <span class="lbl">Min $</span>
      <input
        type="number"
        class="num"
        [value]="minValue() ?? ''"
        (input)="onMinInput($any($event.target).value)"
        placeholder="—"
        min="0"
        step="1000"
        aria-label="Minimum premium"
      />
    </label>
    <span class="sep">–</span>
    <label>
      <span class="lbl">Max $</span>
      <input
        type="number"
        class="num"
        [value]="maxValue() ?? ''"
        (input)="onMaxInput($any($event.target).value)"
        placeholder="—"
        min="0"
        step="1000"
        aria-label="Maximum premium"
      />
    </label>
  </div>
</div>
